import React, { useState, useRef, useMemo } from 'react'
import debounce from '~modules/format/callback/debounce'
import localStorage from '~modules/localStorage'
import Basic from '../basic'

export const Context = React.createContext({})

export default function ScreenSplitView({ children, className = '', ...etc }) {
    const [sidebar, setSidebar] = useState(() => ({
        width: parseInt(localStorage.getItem('splitview-sidebar-width')) || 0,
        show:
            localStorage.getItem('splitview-sidebar-show') !== null
                ? localStorage.getItem('splitview-sidebar-show') == 'true'
                : true
    }))
    const [reader, setReader] = useState({ show: false, fullscreen: false })
    const container = useRef(null)

    const update = useMemo(
        () =>
            debounce((space, obj) => {
                const setter = space == 'sidebar' ? setSidebar : setReader

                setter(prev => {
                    const changed = Object.keys(obj).some(key => prev[key] != obj[key])
                    if (!changed) return prev

                    //persist sidebar preferences
                    if (space == 'sidebar') {
                        if (typeof obj.width == 'number')
                            window.requestAnimationFrame(() =>
                                localStorage.setItem('splitview-sidebar-width', obj.width)
                            )

                        if (typeof obj.show != 'undefined')
                            window.requestAnimationFrame(() =>
                                localStorage.setItem('splitview-sidebar-show', obj.show)
                            )
                    }

                    return { ...prev, ...obj }
                })
            }, 300, { leading: true }),
        []
    )

    const contextValue = useMemo(
        () => ({
            sidebar: {
                ...sidebar,
                toggle: e => {
                    e && e.preventDefault && e.preventDefault()
                    update('sidebar', { show: !sidebar.show })
                },
                close: e => {
                    e && e.preventDefault && e.preventDefault()
                    update('sidebar', { show: false })
                },
                resize: width => {
                    if (container.current)
                        container.current.style.setProperty('--sidebar-width', width + 'px')
                    update('sidebar', { width })
                }
            },
            reader: {
                ...reader,
                update: props => update('reader', props)
            }
        }),
        [sidebar, reader, update]
    )

    return (
        <Basic
            {...etc}
            className={'ui-sv-page ' + className}>
            <div
                ref={container}
                className={`
                    ui-splitview
                    ${sidebar.show ? 'ui-sv-s' : ''}
                    ${reader.show ? 'ui-sv-r' : ''}
                    ${reader.fullscreen ? 'ui-sv-f' : ''}
                `}
                style={sidebar.width ? { '--sidebar-width': sidebar.width + 'px' } : undefined}>
                <Context.Provider value={contextValue}>
                    {children}
                </Context.Provider>
            </div>
        </Basic>
    )
}
